var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default"),
      _vm.hasErrors
        ? _c(
            "div",
            _vm._l(_vm.activeErrorMessages, function(error, i) {
              return _c("div", {
                key: i,
                staticClass: "validate",
                domProps: { innerHTML: _vm._s(error) }
              })
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }